
import React from 'react'

export default function Aspect({ aspect }) {
    return (
        <div className='introduction p10'>
            <div className='max-1400  ma pt10'>
                <div className='flex m-reverse m-wrap'>
                    <div className='w-30 m-100  pr20 text-light size-medium '>
                        {aspect.name}
                    </div>
                    <div className='w-70 m-100 m-mb40  grid grid-2 gap-x-80 gap-y-100 '>
                        {aspect.aspects.map((aspect) => {
                            return <SubAspect aspect={aspect} />
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

function SubAspect({ aspect }) {
    return (
        <div >
            <h2 className='text-light size-medium uppercase m0 pb20'>
                {aspect.name}</h2>
            <div className='bt1 pt20'>
                {aspect.text}
            </div>
        </div>
    )
}